import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'awCardIcon',
})
export class CardIconPipe implements PipeTransform {
  transform(type: string): string {
    return `assets/icons/${type.toLowerCase()}.svg`;
  }
}
